import { createGlobalStyle } from 'styled-components';

/**
 * Style Guide https://www.figma.com/file/O3ikmxQ658tKqvq3irCUqv/Jetvix-UI-kit?type=design&node-id=174-935&t=K7Bn4woVNQ9b673w-4
 */
export const GlobalButtonsStyled = createGlobalStyle`

    .btn {
        font-size: 14px;
        font-weight: 700;

        border-radius: 2rem;
        padding: 12px 32px;
        border-color: transparent;

        &.color-white {
            color: var(--color-white);
        }
    }

    .btn-group-sm > .btn,
    .btn-sm {
        font-size: 16px;
        font-weight: 600;

        border-radius: 16px;
        padding: 8px 12px;
    }

    .btn-group-lg > .btn,
    .btn-lg {
        font-size: 16px;
        font-weight: 600;

        border-radius: 16px;
        padding: 16px 32px;
    }

    .square {
        padding: 0;
        width: 48px;
        height: 48px;
        max-width: 48px;
        max-height: 48px;

        &.btn-lg {
            padding: 0;
            width: 56px;
            height: 56px;
            max-width: 56px;
            max-height: 56px;
        }
    
        &.btn-sm {
            padding: 0;
            width: 40px;
            height: 40px;
            max-width: 40px;
            max-height: 40px;
        }
    }

    .btn-primary {
        &,
        &:disabled,
        &:focus,
        &:hover,
        &:active {
            background: var(--color-primary);
            border: 1px solid var(--color-primary);
            color: #0A0A10;
        }

        &:focus {
            box-shadow: 0 0 0 0.25rem rgb(49 132 253 / 50%);
        }

        &:hover {
            background: var(--color-primary-light);
            border: 1px solid var(--color-primary-light);
        }

        &:disabled {
            opacity: 0.5;
        }
    }
    
    .btn-secondary {  
        &,
        &:disabled,
        &:focus,
        &:hover,
        &:active {
            color: #fff;
            background: transparent;
            border-color: transparent;
        }

        &:hover {
            color: #fff;
            background: var(--color-purple);
            border-color: var(--color-purple);
            text-decoration: none;
        }

        &.active,
        &:active {
            color: #64A7FF;
            background: var(--color-purple);
            border-color: var(--color-purple);
        }

        &:disabled {
            color: var(--text-color-secondary);
        }

        &.negative {
            color: var(--color-negative);
        }
    }

    .btn-tertiary {
        color: var(--color-white);
        background: var(--color-purple);
        border: 1px solid var(--color-purple);

        &:focus {
            color: var(--color-white);
            background: var(--color-purple);
            border: 1px solid var(--color-purple);
            box-shadow: 0 0 0 0.25rem rgb(49 132 253 / 50%);
        }

        &:hover {
            color: var(--color-white);
            background: var(--color-purple-highlight);
            border: 1px solid var(--color-purple-highlight);
        }

        &:active, &.active {
            color: var(--color-white);
            background: var(--color-purple-highlight);
            border: 1px solid var(--color-purple-highlight);
        }

        &:disabled {
            color: var(--text-color-secondary);
            background: #30334F;
            border: 1px solid #30334F;
        }
    }

    .btn-outline-warning {
        &,
        &:disabled,
        &:focus,
        &:hover,
        &:active {
            color: var(--color-yellow);
            background: transparent;
            border-color: transparent;
        }

        svg {
            transition: fill .15s ease-in-out;
            fill: var(--color-yellow);
        }

        &:focus {
            box-shadow: 0 0 0 0.25rem rgb(255 221 60 / 50%);
        }

        &:disabled {
            opacity: 0.5;
        }
    }
    
    .btn-link {
        color: var(--color-main);
        text-decoration: none;

        &:hover,
        &:focus {
            color: var(--color-white);
            text-decoration: underline;
        }
    }

`;